var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lid",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4H21V9H3V4ZM4.5 5.5V7.5H19.5V5.5H4.5Z",
    fill: "#727C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "box",
    d: "M4 9H5.5V18.5H18.5V9H20V20H4V9Z",
    fill: "#727C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M11.25 10.5H12.75V14H15L12 17L9 14H11.25V10.5Z",
    fill: "#727C8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.6d4acf8e66e384216d58fac65ac363a2.svg";
export { ForwardRef as ReactComponent };